var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-download-6589791 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4629 6.12335V9.03202C10.4629 9.2681 10.361 9.48244 10.1969 9.63751L10.1961 9.63678C10.0311 9.79236 9.80463 9.88898 9.55647 9.88898H1.44375C0.944463 9.88898 0.537354 9.50408 0.537354 9.03202V6.12335H1.34761V9.03202C1.34761 9.08132 1.39183 9.12302 1.44375 9.12302H9.55636C9.58342 9.12302 9.60729 9.11324 9.6239 9.09744V9.09598C9.6415 9.07934 9.6525 9.05667 9.6525 9.03202V6.12335H10.4629ZM5.78853 7.48044L7.48572 5.87583V4.79256L5.90524 6.28684V0.887988C5.90524 0.383692 5.09498 0.383692 5.09498 0.887988V6.28684L3.5145 4.79267V5.87583L5.21169 7.48044C5.37207 7.63312 5.63013 7.63197 5.78853 7.48044Z",
    fill: "#5571C6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.994fe8e6b872a0963dfdef2095ac7ec0.svg";
export { ForwardRef as ReactComponent };